/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react';
import { useActivation } from '@context/MobileOne';
import {
  ButtonPrimary,
  FormInputField,
  CardSupport,
  CardInfobox,
  ApiError,
  ScrollToTop,
  ButtonCancelActivation,
  FocusFirstError
} from '@core/index';
import {
  appButtonType,
  appCardStyle,
  appIconsPath,
  appInfoCardSize,
  validCharRegex,
} from '@utils/globalConstant';
import { Form, Formik } from 'formik';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { useA11y } from '@context/Utils';

export function SimDataActivation() {
  // Contexts
  const {
    isLoading,
    phoneNumberActivationForm,
    phoneNumberValidations,
    phoneNumberSubmit,
    formError,
    setFormError,
    setShowActivationHeader
  } = useActivation();
  const { isGenericApiError } = useA11y();

  const handleAPIErrorLink = () => {
    const firstInput = document.querySelector('input');
    if (firstInput) {
      firstInput.focus();
    }
  }

  useEffect(() => {
    setShowActivationHeader(true);
  }, [setShowActivationHeader])
  
  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper>
            {tA11y('ek_reg_sim-data_hdl1').isHtml ? (
              <h2
                className="text-primary"
                dangerouslySetInnerHTML={{
                  __html: tA11y('ek_reg_sim-data_hdl1').content
                }}
              />
            ) : (
              <h2 className="text-primary">{tA11y('ek_reg_sim-data_hdl1').content}</h2>
            )}

            {tA11y('ek_reg_sim-data_txt1').isHtml ? (
              <p
                className="ek-copy-16-medium text-primary my-40"
                dangerouslySetInnerHTML={{
                  __html: tA11y('ek_reg_sim-data_txt1').content
                }}
              />
            ) : (
              <p className="ek-copy-16-medium text-primary my-40">
                {tA11y('ek_reg_sim-data_txt1').content}
              </p>
            )}
            <Formik
              initialValues={phoneNumberActivationForm}
              validationSchema={phoneNumberValidations}
              // BFSG: as not used in NORMA this additional validation function is commented
              // validate={PhoneNumberCustomValidation}
              onSubmit={phoneNumberSubmit}>
              {({
                values: { msisdn, puk },
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                errors,
                setFieldValue
              }) => {
                return (
                  <Form onSubmit={handleSubmit} noValidate>
                    <FormInputField
                      label="ek_global_phone_nmbr_lbl"
                      placeholder="ek_global_phone_nmbr_plc"
                      type="text" // accessibility: we use type text instead of number
                      inputMode="numeric"
                      pattern="[0-9]*"
                      id="msisdn"
                      name="msisdn"
                      value={msisdn}
                      onChange={(e) => {
                        setFormError(null);
                        handleChange({
                          target: {
                            id: 'msisdn',
                            name: 'msisdn',
                            value: e.target.value
                          }
                        });
                      }}
                      onClear={setFieldValue}
                      onBlur={handleBlur}
                      valid={touched.msisdn && !errors.msisdn}
                      invalid={
                        (touched.msisdn && errors.msisdn) || !!(formError && !isGenericApiError)
                      }
                      invalidMessage={touched.msisdn && errors.msisdn ? errors.msisdn : null}
                      // limits to twenty digits
                      maxLength={20}
                      aria-describedby="msisdn-error"
                      checkCharRegex={validCharRegex.MSISDN}
                    />
                    <FormInputField
                      customClass="mt-32 mb-12"
                      label="ek_global_puk_lbl"
                      placeholder="ek_global_puk_plc"
                      type="text" // accessibility: we use type text instead of number
                      inputMode="numeric"
                      pattern="[0-9]*"
                      id="puk"
                      name="puk"
                      value={puk}
                      onChange={(e) => {
                        setFormError(null);
                        handleChange({
                          target: {
                            id: 'puk',
                            name: 'puk',
                            value: e.target.value
                          }
                        });
                      }}
                      onClear={setFieldValue}
                      onBlur={handleBlur}
                      valid={touched.puk && !errors.puk}
                      invalid={(touched.puk && errors.puk) || !!(formError && !isGenericApiError)}
                      invalidMessage={touched.puk && errors.puk ? errors.puk : null}
                      // limits to eight digits
                      maxLength={8}
                      aria-describedby="puk-error"
                      checkCharRegex={validCharRegex.PUK}
                    />
                    <CardInfobox
                      cardStyle={appCardStyle.SECONDARY}
                      cardSize={appInfoCardSize.DEFAULT}
                      cardIcon={appIconsPath.INFO}
                      text="ek_reg_sim-data_infobox_txt"
                    />
                    {formError && (
                      <div className="form-text mt-40 ps-4" aria-live="polite">
                        <ApiError
                          message={formError}
                          isGenericApiError={isGenericApiError}
                          handleAPIErrorLink={handleAPIErrorLink}
                        />
                      </div>
                    )}
                    <div className="row">
                      <div className="col-xxl-5 col-lg-5 col-10 px-0 mx-auto">
                        <ButtonPrimary
                          buttonClass="my-40"
                          buttonType={appButtonType.PRIMARY}
                          buttonContent={tA11y('ek_reg_sim-data_btn1')}
                          label="ek_reg_sim-data_btn1"
                          type="submit"
                          isLoading={isLoading}
                        />
                      </div>
                    </div>
                    <FocusFirstError />
                  </Form>
                );
              }}
            </Formik>
            <CardSupport />
            <div className="d-flex justify-content-center mt-32">
              {/* <Link
                label="ek_reg_cncl_link1"
                iconRight={appIconsPath.CLOSE}
                linkStyle={appLinkStyle.PRIMARY}
                linkSize={appLinkSize.DEFAULT}
                onClick={() => setShowActivationCancelModal(true)}
              /> */}
              <ButtonCancelActivation />
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default SimDataActivation;
